<template>
  <layout-default-app-bar 
    :back-to="true">
    {{ titulo }}
  </layout-default-app-bar>
</template>

<script>
import LayoutDefaultAppBar from '@/layouts/default/AppBar.vue';

export default {
  name: 'PesquisaMarcaCorAppBar',

  components: {
    LayoutDefaultAppBar,
  },

  computed: {
    titulo() {
      const tabela = (this.$route.query.tabela || this.$route.query.tipo || 'cor').toLowerCase();
      const titulos = {
        cor: 'Pesquisa de Cores',
        marcaveiculo: 'Pesquisa de Marcas de Veículo',
        marca: 'Pesquisa de Marcas de Veículo',
      };
      return titulos[tabela] || 'Pesquisa';
    }
  }
};
</script>
